import(/* webpackMode: "eager", webpackExports: ["LayoutHolder"] */ "/app/app/[locale]/layoutHolder.tsx");
;
import(/* webpackMode: "eager" */ "/app/assets/_styles/globals.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Hotjar"] */ "/app/components/common/HotJar/HotJar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StructuredData"] */ "/app/components/common/StructuredData/StructuredData.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PixelManager"] */ "/app/components/Pixel/PixelManager.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/[locale]/layout.tsx\",\"import\":\"Sora\",\"arguments\":[{\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\"],\"variable\":\"--font-sora\",\"style\":[\"normal\"],\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"sora\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"app/[locale]/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"../../assets/fonts/avantGardeLight.ttf\",\"weight\":\"400\",\"style\":\"normal\"},{\"path\":\"../../assets/fonts/AvantGardeBold.ttf\",\"weight\":\"800\",\"style\":\"normal\"}],\"variable\":\"--font-avant\",\"display\":\"swap\"}],\"variableName\":\"avantGarde\"}");
;
import(/* webpackMode: "eager", webpackExports: ["ContactProvider"] */ "/app/provider/ContextForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DuckProvider"] */ "/app/provider/DuckContext.tsx");
